import React, { useEffect, useState } from "react";
import { ChevronDownIcon, PlusIcon } from "@heroicons/react/outline";
import { ArrowLeftIcon, SearchIcon } from "@heroicons/react/solid";
import Cookies from "js-cookie";
import Login from "../UserAuth/Login/Login";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import axiosInstance from "../../../Service/Interceptor";

function CreateVendor() {
  const baseUrl = process.env.REACT_APP_BASE_URL_ONE;
  const dispatch = useDispatch();
  let token = Cookies.get("access_token");

  const { isLoaded } = useLoadScript({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyCF86ydjbpe01AUAqhdeHS6XeD5Vuj931E",
  });

  const center={
    lat: 23.918284555269043,
    lng: 90.36896852842271,
  }

  const ClickEvent = (e, a, c) => {
    setLocation(e.latLng);
    toast.success("Your locaton selected!!", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
   
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  const [location, setLocation] = useState(null);

  const onCreateStore = (data) => {

    const formData = {
      shop_name: data.shop_name,
      shop_email: data.shop_email,
      shop_address: data.shop_address,
      representative_name: data.representative_name,
      representative_email: data.representative_email,
      representative_number: data.representative_number,
      latitude: location != null && location.lat(),
      longitude: location != null && location.lng(),
      password: data.password,
      confirm_password: data.confirm_password,
    };
    console.log(formData)

    axiosInstance.post(`users/api/v1/users/regional-admin/vendor/`,formData)
    .then((res)=>{
      toast.success(`${res.data.message}`, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      })
      reset()
     
    })
    .catch((err)=>{
      if(err.response.data.non_field_errors){
        toast.error(`${err.response.data.non_field_errors}`, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        })
  
         }else if(err.response.data.password){
  
        toast.error(`${err.response.data.password}`, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        })
        
         }else if(err.response.data.confirm_password){
  
        toast.error(`${err.response.data.confirm_password}`, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        })
        
         }
         else if(err.response.data.latitude || err.response.data.longitude){
  
        toast.error("Select your location", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        })
  
         }else if(err.response.data.representative_email || err.response.data.shop_email){
  
        toast.error("Enter valid Email", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        })
  
         }
    })

  };

  return (
    <>
      {token ? (
        <>
          <section className="gap-x-4  justify-center h-full w-full pt-2 pb-6 px-4">
            <div className="col-span-12 flex justify-between items-center w-full pb-1 border-b border-gray-200">
              <h1 className="text-lg font-semibold">Create Vendor</h1>
              <button
                className="flex justify-start items-center text-white text-sm bg-blue-600 font-medium  px-2 py-1 shadow-2xl cursor-pointer rounded-md"
                onClick={() => window.history.back()}
              >
                <ArrowLeftIcon className="w-4 mx-1" /> Back
              </button>
            </div>

            <form onSubmit={handleSubmit(onCreateStore)}  className="grid grid-cols-12 gap-x-4 mb-5  my-5 ">

              <div className="col-span-6 bg-white py-5 px-5 drop-shadow-[0px_8px_10px_rgba(44,141,255,0.29)]  ">

                <h1 className="mb-5 font-semibold text-lg  border-b border-gray-300">Enter Shop Info</h1>

                <div className="w-full mb-4 space-y-2">
                  <label className="text-black ">Give The Shop Name</label>
                  <input
                    type="text"
                    name="shop_name"
                    placeholder="Enter shop name"
                    className="w-full text-gray-500 border border-gray-400 rounded-md px-4 py-2 focus:outline-none placeholder-slate-400 font-normal"
                    {...register("shop_name", {
                      required: true,
                    })}
                  />
                  {errors.shop_name?.type === "required" && (
                            <p className="text-red-600 font-noraml italic">
                              shop name required
                            </p>
                          )}
                </div>

                <div className="w-full mb-4 space-y-2">
                  <label className="text-black ">Shop Email Address(for seller dashboard login) </label>
                  <input
                    type="text"
                    name="shop_email"
                    placeholder="Enter shop name"
                    className="w-full text-gray-500 border border-gray-400 rounded-md px-4 py-2 focus:outline-none placeholder-slate-400 font-normal"
                    {...register("shop_email", {
                      required: true,
                    })}
                  />
                  {errors.shop_email?.type === "required" && (
                            <p className="text-red-600 font-noraml italic">
                              shop email required
                            </p>
                          )}
                </div>

                <div className="w-full mb-4 space-y-2">
                  <label className="text-black ">Shop  Address </label>
                  <input
                    type="text"
                    name="shop_address"
                    placeholder="Enter shop name"
                    className="w-full text-gray-500 border border-gray-400 rounded-md px-4 py-2 focus:outline-none placeholder-slate-400 font-normal"
                    {...register("shop_address", {
                      required: true,
                    })}
                  />
                  {errors.shop_address?.type === "required" && (
                            <p className="text-red-600 font-noraml italic">
                              shop address required
                            </p>
                          )}
                </div>

                <div className="w-full mb-4 space-y-2">
                  <label className="text-black ">Give Password </label>
                  <input
                    type="text"
                    name="password"
                    placeholder="Enter shop name"
                    className="w-full text-gray-500 border border-gray-400 rounded-md px-4 py-2 focus:outline-none placeholder-slate-400 font-normal"
                    {...register("password", {
                      required: true,
                    })}
                  />
                  {errors.password?.type === "required" && (
                            <p className="text-red-600 font-noraml italic">
                              password required
                            </p>
                          )}
                </div>

                <div className="w-full mb-4 space-y-2">
                  <label className="text-black ">Confirm Password </label>
                  <input
                    type="text"
                    name="confirm_password"
                    placeholder="Enter confirm password"
                    className="w-full text-gray-500 border border-gray-400 rounded-md px-4 py-2 focus:outline-none placeholder-slate-400 font-normal"
                    {...register("confirm_password", {
                      required: true,
                    })}
                  />
                  {errors.confirm_password?.type === "required" && (
                            <p className="text-red-600 font-noraml italic">
                             confirm password required
                            </p>
                          )}
                </div>

              </div>

             
              <div className="col-span-6 bg-white py-5 px-5 drop-shadow-[0px_8px_10px_rgba(44,141,255,0.29)] ">

                <h1 className="mb-5 font-semibold text-lg  border-b border-gray-300">Enter Shop Reprsentative's Info</h1>

                <div className="w-full mb-4 space-y-2">
                  <label className="text-black ">Reprsentative Name</label>
                  <input
                    type="text"
                    name="representative_name"
                    placeholder="Enter shop name"
                    className="w-full text-gray-500 border border-gray-400 rounded-md px-4 py-2 focus:outline-none placeholder-slate-400 font-normal"
                    {...register("representative_name", {
                      required: true,
                    })}
                  />
                  {errors.representative_name?.type === "required" && (
                            <p className="text-red-600 font-noraml italic">
                             representative name required
                            </p>
                          )}
                </div>

                <div className="w-full mb-4 space-y-2">
                  <label className="text-black ">Representative Email Address</label>
                  <input
                    type="email"
                    name="representative_email"
                    placeholder="Enter representative email"
                    className="w-full text-gray-500 border border-gray-400 rounded-md px-4 py-2 focus:outline-none placeholder-slate-400 font-normal"
                    {...register("representative_email", {
                      required: true,
                    })}
                  />
                  {errors.representative_email?.type === "required" && (
                            <p className="text-red-600 font-noraml italic">
                              shop email required
                            </p>
                          )}
                </div>

                <div className="w-full mb-4 space-y-2 pb-5 border-b border-gray-500">
                  <label className="text-black "> Representative Phone Number </label>
                  <input
                    type="text"
                    name="representative_number"
                    placeholder="Enter representative phone number"
                    className="w-full text-gray-500 border border-gray-400 rounded-md px-4 py-2 focus:outline-none placeholder-slate-400 font-normal"
                    {...register("representative_number", {
                      required: true,
                    })}
                  />
                  {errors.representative_number?.type === "required" && (
                            <p className="text-red-600 font-noraml italic">
                             representative phone number required
                            </p>
                          )}
                </div>

                <div className="w-full mb-4 space-y-2">
                  <label className="text-black ">Locate Shop on map </label>
                  <GoogleMap
                      mapContainerStyle={{ width: "auto", height: "250px" }}
                      zoom={15}
                      center={center}
                      onClick={ClickEvent}
                    >
                      {/* <Marker
                        position={{
                          lat: addressData?.location_data.latitude,
                          lng: addressData?.location_data.longitude,
                        }}
                      /> */}
                    </GoogleMap>
                  {errors.location?.type === "required" && (
                            <p className="text-red-600 font-noraml italic">
                            location required
                            </p>
                          )}
                </div>


                

              </div>
              <div className="col-span-12  py-5 px-5 drop-shadow-[0px_8px_10px_rgba(44,141,255,0.29)] ">
                <div className="flex justify-center w-full">
                <input
                          type="submit"
                          value="Create & Confirm Store"
                          className="bg-green-600 py-2 px-5  w-1/3 rounded-lg text-white text-base   cursor-pointer"
                        />
                      
                </div>
            
              </div>
            </form>
          </section>
        </>
      ) : (
        <Login />
      )}
    </>
  );
}

export default CreateVendor;
